import { Component, Input, Output, EventEmitter } from '@angular/core';

import { IVideoCommentMenuConfig } from './IVideoCommentMenuConfig';
import { VideoCommentMenuEventType } from './VideoCommentMenuContract';

import styles from './video-comment-menu.module.less';

@Component({
	selector: 'video-comment-menu',
	templateUrl: './VideoCommentMenu.Component.html'
})
export class VideoCommentMenuComponent {
	@Input() public menuConfig: IVideoCommentMenuConfig;
	@Output() private onMenuItemClick: EventEmitter<any> = new EventEmitter();

	public readonly eventTypes: typeof VideoCommentMenuEventType = VideoCommentMenuEventType;
	public readonly styles = styles;

	public menuItemClick(eventType: VideoCommentMenuEventType) {
		this.onMenuItemClick.emit({ eventType });
	}

	public get isMenuVisible(): boolean {
		return !this.menuConfig.isCommentDeleted || this.menuConfig.repliesCount > 0;
	}
}
